// extracted by mini-css-extract-plugin
export default {"backButton":"goBackButton_backButton__nuA9B"};